import React from 'react';
import { motion } from 'framer-motion';
import { AlertCircle, BatteryWarning, BrainCircuit } from 'lucide-react';
export function ProblemSection() {
  return <section className="py-24 px-6 bg-white" data-id="element-128">
      <div className="max-w-4xl mx-auto" data-id="element-129">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.6
      }} className="text-center mb-16" data-id="element-130">
          <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-6" data-id="element-131">
            The moment you realize “rest” isn’t working
          </h2>
          <p className="text-xl text-slate-600 leading-relaxed max-w-2xl mx-auto" data-id="element-132">
            You finally get a break. The meeting ends. The emails stop. You sit
            down. And instead of feeling relieved, you feel…{' '}
            <span className="font-semibold text-teal-700" data-id="element-133">wired</span>.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8 mb-16" data-id="element-134">
          {[{
          icon: <BatteryWarning className="w-8 h-8 text-amber-500" data-id="element-135" />,
          title: 'Physical Tension',
          desc: "Your jaw is tight. Your chest feels heavy. You can't take a full, deep breath."
        }, {
          icon: <BrainCircuit className="w-8 h-8 text-teal-600" data-id="element-136" />,
          title: 'Mental Sprinting',
          desc: 'Your body stops moving, but your brain opens 27 new tabs of worry and planning.'
        }, {
          icon: <AlertCircle className="w-8 h-8 text-rose-500" data-id="element-137" />,
          title: 'Numbing Out',
          desc: 'You scroll, snack, or clean—doing anything to outrun the silence.'
        }].map((item, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-[#faf9f7] p-8 rounded-2xl border border-slate-100" data-id="element-138">
              <div className="mb-4 bg-white w-14 h-14 rounded-full flex items-center justify-center shadow-sm" data-id="element-139">
                {item.icon}
              </div>
              <h3 className="text-lg font-bold text-slate-900 mb-3" data-id="element-140">
                {item.title}
              </h3>
              <p className="text-slate-600 leading-relaxed" data-id="element-141">{item.desc}</p>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-teal-50 p-8 md:p-12 rounded-3xl text-center border border-teal-100" data-id="element-142">
          <p className="text-2xl md:text-3xl font-serif text-teal-900 font-medium italic" data-id="element-143">
            "You’re not dramatic. You’re not weak.{' '}
            <br className="hidden md:block" data-id="element-144" />
            You’re over-activated."
          </p>
        </motion.div>
      </div>
    </section>;
}